/*
 * @Description: 二代返点
 * @Author: 杨志航
 * @Date: 2026-08-13 14:57:40
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Button,
  Select,
  Alert,
  DatePicker,
  Input,
  message,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Import from '@/components/Import'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { MonthPicker } = DatePicker
const dateFormat = 'YYYY-MM'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const Second = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [oldOaCompanyList, setOldOaCompanyList] = useState([])
  const [importVisible, setImportVisible] = useState(false)
  const ImportRef = useRef()

  useEffect(() => {
    resetParams()
    getSearchData()
    getList()
  }, [])

  const getSearchData = () => {
    Promise.all([
      api.getSelectCompanyList({ limit: global.paramsLimit }),
      api.getOldOaCompanyList(),
    ]).then(data => {
      setCompanyList(data[0].list)
      setOldOaCompanyList(data[1])
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    searchParams.config_type = 2
    api.getOrderProfitConfigList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.year_month) {
          vals.year_month = vals.year_month.format(dateFormat)
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const handleCopyFirst = () => {
    api.copyFirstRebateToNextMonth({
      config_type: 2
    }).then(() => {
      message.success('操作成功')
      onReset()
    })
  }

  const onShowImportDialog = () => {
    ImportRef.current.onRemoved()
    setImportVisible(true)
  }

  const onConfirmImport = (fileList) => {
    if (fileList[0].status !== 'removed') {
      api.importOrderProfitConfig({
        config_type: 2,
        path: fileList[0].url
      }).then(res => {
        message.success('导入成功')
        ImportRef.current.onLoading()
        setImportVisible(false)
        onReset()
      }).catch(res => {
        ImportRef.current.onLoading()
      })
    } else {
      message.error('请导入模板')
    }
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="厂商ID关键字">
            {getFieldDecorator('vendor_id_keyword')(<Input placeholder="请输入厂商ID关键字" />)}
          </FormItem>
          <FormItem label="易企信提单公司">
            {getFieldDecorator('company_id')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="老OA提单公司">
            {getFieldDecorator('old_oa_company_id')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                oldOaCompanyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="年月">
            {getFieldDecorator('year_month')(<MonthPicker placeholder="请选择月份" style={{ width: '100%' }} />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={handleCopyFirst}>复制一返到下月</Button>
        <Button type="primary" onClick={onShowImportDialog} style={{ marginLeft: 15 }}>二代返点导入</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column title="年月" dataIndex="year_month" />
        <Column title="厂商ID关键字" dataIndex="vendor_id_keyword" />
        <Column title="易企信提单公司" dataIndex="company_name" />
        <Column title="老OA提单公司" dataIndex="old_oa_company_name" />
        <Column title="一返" dataIndex="first_rebate" />
        <Column title="二返" dataIndex="second_rebate" />
      </Table>
    </div>
    <Import
      title="二代返点导入"
      onSearch={onConfirmImport}
      visibleFile={importVisible}
      onCloseImport={() => setImportVisible(false)}
      ImportTemplate="/api/File/DownTemplate?url=/templates/订单利润二代返点模版.xlsx&name=二代返点导入模版"
      ImportRef={ImportRef}
    />
  </>
}

export default Form.create()(Second)
